module.exports = __webpack_public_path__ + "img/email-bold-20x20.2e722d67.svg";